function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".clsInvoices-1{fill:#c8c8c8;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Faktura_papierowa",
  "data-name": "Faktura papierowa"
}, /*#__PURE__*/React.createElement("path", {
  className: "clsInvoices-1",
  d: "M14.09,15h-8a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h8a.5.5,0,0,1,.5.5A.51.51,0,0,1,14.09,15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "clsInvoices-1",
  d: "M14.09,18.08H10.56a.5.5,0,0,1,0-1h3.53a.5.5,0,0,1,0,1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "clsInvoices-1",
  d: "M14.09,12.86h-8a.5.5,0,0,1,0-1h8a.5.5,0,0,1,0,1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "clsInvoices-1",
  d: "M16.33,2.7H8.44a.49.49,0,0,0-.35.15L3.43,7.51a.45.45,0,0,0-.15.35V20.2a.5.5,0,0,0,.5.5H16.33a.5.5,0,0,0,.5-.5V3.2A.51.51,0,0,0,16.33,2.7ZM7.94,4.41v3H5ZM15.83,19.7H4.28V8.36H8.44a.5.5,0,0,0,.5-.5V3.7h6.89Z"
}));

var SvgFakturySider = function SvgFakturySider(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFakturySider, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FakturySider.08caadc1.svg";
export { ForwardRef as ReactComponent };